// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + "admin" + "." + "63d520cc" + ".css"; };